import { IData } from '@hooks/useData';
import { useMenu } from '@hooks/useMenu';
import { useModalWindow } from '@hooks/useModalWindow';
import { AtividadeModal } from '@mod/Atividade/AtividadeModal';
import { FaturaTable } from '@mod/Cliente/Detalhes/Faturas/FaturaTable';
import { FaturaCancelarModal } from '@mod/Fatura/FaturaCancelarModal';
import { ICliente } from '@model/Cliente';
import { IComboEmpresa } from '@model/Empresa';
import IFatura from '@model/Fatura';
import { IComboFaturaStatus } from '@model/FaturaStatus';
import { IFaturaFilter } from '@services/ClienteService';
import React from 'react';
import { FaturaFilter } from './FaturaFilter';
import { FaturaMenu } from './FaturaMenu';
import { FaturaRegistrarModal } from './FaturaRegistrarModal';


export type ClienteDetalhesFaturasProps = {
    cliente: ICliente
    data: IData<IFatura, IFaturaFilter>
    faturaStatusCombo: IComboFaturaStatus
    empresaCombo: IComboEmpresa
    isLoading: boolean
}

export function ClienteDetalhesFaturas ({ cliente, data, faturaStatusCombo, isLoading, empresaCombo }: ClienteDetalhesFaturasProps) {
    const menu = useMenu();
    const cancelarModal = useModalWindow();
    const faturaRegistrarModal = useModalWindow()
    const gerarFaturasAntecipadas = useModalWindow();

    const atividadeModal = useModalWindow();

    return (
        <React.Fragment>
            <FaturaFilter
                filter={data.filter}
                faturaStatusCombo={faturaStatusCombo}
                isLoading={isLoading}
                registrarFaturaModal={faturaRegistrarModal}
                gerarFaturasAntecipadas={gerarFaturasAntecipadas}
            />
            
            <FaturaTable
                data={data}
                menu={menu}
                isLoading={isLoading}
            />

            <FaturaRegistrarModal 
                modal={faturaRegistrarModal}
                cliente={cliente}
                empresaCombo={empresaCombo}
                onFaturaRegistrada={data.filter.handleFilterRequest}
            />

            {
                data.focusedRow !== undefined && (
                    <React.Fragment>
                        <FaturaMenu 
                            menu={menu}
                            fatura={data.focusedRow}
                            cancelarModal={cancelarModal}
                        />

                        <FaturaCancelarModal 
                            modal={cancelarModal}
                            fatura={data.focusedRow}
                            onFaturaCancelada={data.handleUpdateFocusedRow}
                        />

                        <AtividadeModal 
                            modal={atividadeModal}
                            entidade='fatura'
                            chaves={{
                                faturaId: data.focusedRow.faturaId
                            }}
                        />
                    </React.Fragment>
                )
            }
        </React.Fragment>
    )
}